<div class="project-attachments-upload">
    <div class="loader" [hidden]="!submitted">
        <div class="dimmed" >
            <div class="dimmed_box"></div>
            <div class="dimmed_flex">
                <div class="dimmed_title"></div>
                <div class="dimmed_title"></div>
            </div>
        </div>
    </div>
   
    <div [hidden]="submitted">
        <core-files-upload (response)="files = $event" (onUploading)="uploading = $event"></core-files-upload>
    </div>

    <div class="box_fieldset">
      <core-helpers-forms-button-white [disabled]="submitted || uploading || files.length == 0" [text]="'UPLOAD'" (click)= "onSubmit()"></core-helpers-forms-button-white>
      <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
    </div>

</div>
